module.exports = __webpack_public_path__ + "static/logo-aceafabca40c92080b993d15f6e2204e.png";